<template>
    <span>
        <router-link
            tag="a"
            :to="`/radios?organization_id=${row.id}`"
            class="view icon-view"
            title="View"
        />
    </span>
</template>

<script>
export default {
    components: {},

    props: {
        row: {
            type: Object,
            required: true,
        },
    },
}
</script>
